import BaseApi from '../base';

class CoreApi extends BaseApi {
  /**
   * @param {string} username
   * @param {string} password
   * @returns {Promise<*>}
   */
  async logIn(username, password) {
    const data = {username, password};

    return this.makeRequest(this.METHOD_POST, 'login', null, data);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async logOut(token) {
    return this.makeRequest(this.METHOD_POST, 'logout', token);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getProfile(token) {
    return this.makeRequest(this.METHOD_GET, 'profile', token);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getClients(token) {
    return this.makeRequest(this.METHOD_GET, 'clients', token);
  }

  /**
   * @param {string} token
   * @param {string} user
   * @returns {Promise<*>}
   */
  async getNotes(token, user) {
    return this.makeRequest(this.METHOD_GET, `notes?user=${user}`, token);
  }

  /**
   * @param {string} token
   * @param {string} user
   * @param {string} text
   * @returns {Promise<*>}
   */
  async addNote(token, user, text) {
    return this.makeRequest(this.METHOD_POST, 'notes', token, { text, user });
  }

  /**
   * @param {string} token
   * @param {string} id
   * @param {string} text
   * @returns {Promise<*>}
   */
  async updateNote(token, id, text) {
    return this.makeRequest(this.METHOD_POST, `notes/${id}`, token, { text });
  }

  /**
   * @param {string} token
   * @param {string} user
   * @returns {Promise<*>}
   */
  async getConclusions(token, user) {
    return await this.makeRequest(this.METHOD_GET, `conclusions?user=${user}`, token);
  }

  /**
   * @param {string} token
   * @param data
   * @returns {Promise<*>}
   */
  async addConclusion(token, data) {
    return this.makeRequest(this.METHOD_POST, 'conclusions', token, data);
  }

  /**
   * @param {string} token
   * @param {string} id
   * @param data
   * @returns {Promise<*>}
   */
  async updateConclusion(token, id, data) {
    return this.makeRequest(this.METHOD_POST, `conclusions/${id}`, token, data);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getFunctionals(token) {
    return await this.makeRequest(this.METHOD_GET, 'functionals', token);
  }

  /**
   * @param {string} token
   * @param {string} user
   * @returns {Promise<*>}
   */
  async getFunctionalEstablishments(token, user) {
    return await this.makeRequest(this.METHOD_GET, `functionals/establishment?user=${user}`, token);
  }

  /**
   * @param {string} token
   * @param data
   * @returns {Promise<*>}
   */
  async addFunctionalEstablishment(token, data) {
    return this.makeRequest(this.METHOD_POST, 'functionals/establishment', token, data);
  }

  /**
   * @param {string} token
   * @param {string} id
   * @param data
   * @returns {Promise<*>}
   */
  async updateFunctionalEstablishment(token, id, data) {
    return this.makeRequest(this.METHOD_POST, `functionals/establishment/${id}`, token, data);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getDiagnoses(token) {
    return await this.makeRequest(this.METHOD_GET, 'diagnoses', token);
  }

  /**
   * @param {string} token
   * @param {string} user
   * @returns {Promise<*>}
   */
  async getDiagnosisEstablishments(token, user) {
    return await this.makeRequest(this.METHOD_GET, `diagnoses/establishment?user=${user}`, token);
  }

  /**
   * @param {string} token
   * @param data
   * @returns {Promise<*>}
   */
  async addDiagnosisEstablishment(token, data) {
    return this.makeRequest(this.METHOD_POST, 'diagnoses/establishment', token, data);
  }

  /**
   * @param {string} token
   * @param {string} id
   * @param data
   * @returns {Promise<*>}
   */
  async updateDiagnosisEstablishment(token, id, data) {
    return this.makeRequest(this.METHOD_POST, `diagnoses/establishment/${id}`, token, data);
  }

  /**
   * @param {string} token
   * @param {string} user
   * @returns {Promise<*>}
   */
  async getAnamneses(token, user) {
    return await this.makeRequest(this.METHOD_GET, `anamnesis?user=${user}`, token);
  }

  /**
   * @param {string} token
   * @param data
   * @returns {Promise<*>}
   */
  async addAnamnesis(token, data) {
    return this.makeRequest(this.METHOD_POST, 'anamnesis', token, data);
  }

  /**
   * @param {string} token
   * @param {string} id
   * @param data
   * @returns {Promise<*>}
   */
  async updateAnamnesis(token, id, data) {
    return this.makeRequest(this.METHOD_POST, `anamnesis/${id}`, token, data);
  }
}

export default CoreApi;
